import React from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { Grid, Modal, Typography, TextField, Stack } from "@mui/material";

import { Button, Alert } from "../../common/styled";
import ModalBox from "../../../common/ModalBox";

import useLLMConfig from "../../../../hooks/user/useLLMConfig";

function CreateAPITokenModal({ open, handleClose, viewHandleOpen, setCreatedToken, zoneUid }) {
  const { createAPIToken } = useLLMConfig();

  return (
    <Formik
      initialValues={{
        name: "",
        expires_in: 0,
      }}
      validationSchema={Yup.object().shape({
        name: Yup.string().required("Token name is required"),
        expires_in: Yup.number().integer("Expiration days must be an integer").min(1, "Expiration days must be at least 1"),
      })}
      onSubmit={async (values, { resetForm, setErrors, setStatus, setSubmitting }) => {
        try {
          values.submit = undefined;
          const token = await createAPIToken(zoneUid, values);
          if (token) {
            setCreatedToken(token);
            handleClose();
            viewHandleOpen();
            resetForm();
          } else {
            const message = "Something went wrong";
            setStatus({ success: false });
            setErrors({ submit: message });
            setSubmitting(false);
          }
        } catch (error) {
          const message = error.message || "Something went wrong";
          setStatus({ success: false });
          setErrors({ submit: message });
          setSubmitting(false);
        }
      }}
    >
      {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
        <React.Fragment>
          <Modal
            open={open}
            onClose={(_, reason) => {
              if (reason !== "backdropClick") {
                handleClose();
              }
            }}
          >
            <ModalBox sx={{ width: "60vw" }} title="Create API Token" handleClose={handleClose}>
              <form noValidate onSubmit={handleSubmit}>
                <Grid container p={4} spacing={3}>
                  <Grid item xs={12}>
                    {errors.submit && (
                      <Alert mt={2} mb={3} variant="outlined" severity="error">
                        {errors.submit}
                      </Alert>
                    )}
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack direction="column" spacing={2} alignItems="flex-start">
                      <Typography>Token Name</Typography>
                      <TextField
                        fullWidth
                        name="name"
                        error={Boolean(touched.name && errors.name)}
                        helperText={touched.name && errors.name}
                        value={values.name}
                        onBlur={handleBlur}
                        onChange={handleChange}
                      />
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack direction="column" spacing={2} alignItems="flex-start">
                      <Typography>Expiration Days</Typography>
                      <TextField
                        fullWidth
                        name="expires_in"
                        type="number"
                        error={Boolean(touched.expires_in && errors.expires_in)}
                        helperText={touched.expires_in && errors.expires_in}
                        value={values.expires_in}
                        onBlur={handleBlur}
                        onChange={handleChange}
                      />
                    </Stack>
                  </Grid>
                  <Grid item xs={12} textAlign={"right"} pt={4}>
                    <Stack direction="row" spacing={2} justifyContent="flex-end" mt={4}>
                      <Button variant="outlined" color="secondary" size="modal" onClick={handleClose}>
                        Cancel
                      </Button>
                      <Button type="submit" variant="contained" color="success" size="modal" disabled={isSubmitting}>
                        Create
                      </Button>
                    </Stack>
                  </Grid>
                </Grid>
              </form>
            </ModalBox>
          </Modal>
        </React.Fragment>
      )}
    </Formik>
  );
}

export default CreateAPITokenModal;
